import { HeadlinesApi } from 'api/HeadlinesApi';
import { apiClient } from 'container/apiClient';

export const headlinesApi = new HeadlinesApi(apiClient);
